import { SparklesIcon } from "lucide-react"

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

/**
 * Marks a field whose value we supplied rather than the borrower typing it.
 *
 * The badge carries the signal on its own, so no hover or click is needed to
 * spot one. A Popover rather than a Tooltip, following `FieldInfo`: Radix
 * tooltips have no touch support.
 */
export function PrefilledBadge({ note }: { note?: string }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-slot="form-label-prefilled"
          // Opens with the visible text, so the accessible name and the
          // label a voice-control user reads out loud still match.
          aria-label="Prefilled: why this is filled in"
          className="bg-primary/10 text-primary hover:bg-primary/15 ml-2 inline-flex shrink-0 cursor-pointer items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium transition-colors"
        >
          <SparklesIcon className="size-3" />
          Prefilled
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="max-w-70 text-[12.5px] leading-[1.45]"
      >
        {note ??
          "We filled this in from what you told us. Check it's right — you can change it."}
      </PopoverContent>
    </Popover>
  )
}
